// extracted by mini-css-extract-plugin
export default {"Container":"WatchPageProducts_Container__Cf68g","Title":"WatchPageProducts_Title__uOzJt"};